import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20interior%20with%20warm%20golden%20stage%20lighting%2C%20elegant%20movie%20theater%20atmosphere%2C%20plush%20red%20and%20gold%20seats%2C%20dramatic%20spotlight%20effect%2C%20luxurious%20cinema%20hall%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20professional%20interior%20photography%2C%20soft%20atmospheric%20glow&width=1800&height=800&seq=hero-bg-97video&orientation=landscape"
          alt="97视频 - 免费高清在线视频观看平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
            海量高清视频，<strong className="text-accent-500">免费</strong>在线观看
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto">
            电影、电视剧、综艺、动漫、纪录片 —— 高清不缓冲，随时随地畅享极致观影体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/dianying"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm whitespace-nowrap transition-all cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              开始观看
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-full text-sm whitespace-nowrap backdrop-blur-sm transition-all cursor-pointer border border-white/20"
            >
              <i className="ri-information-line mr-2"></i>
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10 flex-wrap">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">5000万+</div>
              <div className="text-xs text-white/60 mt-1">累计用户</div>
            </div>
            <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-500">10万+</div>
              <div className="text-xs text-white/60 mt-1">视频资源</div>
            </div>
            <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">98.5%</div>
              <div className="text-xs text-white/60 mt-1">用户好评</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}